"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DynamicConfig_1 = __importDefault(require("./DynamicConfig"));
var ErrorBoundary_1 = __importDefault(require("./ErrorBoundary"));
var Errors_1 = require("./Errors");
var Layer_1 = __importDefault(require("./Layer"));
var StatsigIdentity_1 = __importDefault(require("./StatsigIdentity"));
var StatsigLogger_1 = __importDefault(require("./StatsigLogger"));
var StatsigNetwork_1 = __importDefault(require("./StatsigNetwork"));
var StatsigSDKOptions_1 = __importDefault(require("./StatsigSDKOptions"));
var StatsigStore_1 = __importStar(require("./StatsigStore"));
var ResponseVerification_1 = require("./utils/ResponseVerification");
var StatsigLocalStorage_1 = __importDefault(require("./utils/StatsigLocalStorage"));
var Timing_1 = require("./utils/Timing");
var LogEvent_1 = __importDefault(require("./LogEvent"));
var LocalOverrides_1 = require("./LocalOverrides");
var StatsigClient = /** @class */ (function () {
    function StatsigClient(sdkKey, user, options) {
        var _this = this;
        this._initCalled = false;
        this._pendingInitPromise = null;
        this._sdkKey = null;
        this._logLayerParameterExposureForLayer = function (layer, parameterName, isManualExposure) {
            if (isManualExposure === void 0) { isManualExposure = false; }
            var allocatedExperiment = '';
            var exposures = layer._undelegatedSecondaryExposures;
            var isExplicit = layer._explicitParameters.includes(parameterName);
            if (isExplicit) {
                allocatedExperiment = layer._allocatedExperimentName;
                exposures = layer._secondaryExposures;
            }
            _this._logger.logLayerExposure(_this._identity._user, layer._name, layer._ruleID, exposures, allocatedExperiment, parameterName, isExplicit, layer._evaluationDetails, isManualExposure, _this._store.getBootstrapMetadata());
        };
        if ((options === null || options === void 0 ? void 0 : options.localMode) !== true &&
            (typeof sdkKey !== 'string' || !sdkKey.startsWith('client-'))) {
            throw new Errors_1.StatsigInvalidArgumentError('Invalid key provided.  You must use a Client SDK Key from the Statsig console to initialize the sdk');
        }
        this._sdkKey = sdkKey;
        this._startTime = (0, Timing_1.now)();
        this._options = new StatsigSDKOptions_1.default(options);
        this._errorBoundary = new ErrorBoundary_1.default(sdkKey, this._options);
        this._ready = false;
        StatsigLocalStorage_1.default.disabled = this._options.disableLocalStorage;
        this._overrides = (0, LocalOverrides_1.loadOverridesFromLocalStorage)();
        this._identity = new StatsigIdentity_1.default(sdkKey, this._normalizeUser(user !== null && user !== void 0 ? user : null), this._options.overrideStableID);
        this._network = new StatsigNetwork_1.default(this._options, this._identity, this._errorBoundary);
        this._logger = new StatsigLogger_1.default(this._options, this._identity, this._network, this._errorBoundary);
        this._store = new StatsigStore_1.default(this._identity, this._logger.logConfigDefaultValueFallback, this._options.initializeValues);
        this._errorBoundary._setStatsigMetadata(this._identity._statsigMetadata);
        if (this._options.initializeValues != null) {
            this._ready = true;
            this._initCalled = true;
            setTimeout(function () { return _this._delayedSetup(); }, 20);
        }
    }
    StatsigClient.prototype.setInitializeValues = function (initializeValues) {
        var _this = this;
        this._errorBoundary._capture('setInitializeValues', function () {
            _this._store.bootstrap(initializeValues);
            if (!_this._ready) {
                // the sdk is usable and considered initialized when configured
                // with initializeValues
                _this._ready = true;
                _this._initCalled = true;
            }
            // we wont have access to window/document/localStorage if these run on the server
            // so try to run whenever this is called
            _this._logger.sendSavedRequests();
        }, function () {
            _this._ready = true;
            _this._initCalled = true;
        });
    };
    StatsigClient.prototype.initializeAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this._errorBoundary._capture('initializeAsync', function () { return __awaiter(_this, void 0, void 0, function () {
                        var user;
                        var _this = this;
                        return __generator(this, function (_a) {
                            if (this._pendingInitPromise != null) {
                                return [2 /*return*/, this._pendingInitPromise];
                            }
                            if (this._ready) {
                                return [2 /*return*/, Promise.resolve()];
                            }
                            this._initCalled = true;
                            if (this._options.localMode) {
                                return [2 /*return*/, Promise.resolve()];
                            }
                            user = this._identity._user;
                            this._pendingInitPromise = this._fetchAndSaveValues(user, this._options.initTimeoutMs)
                                .then(function () {
                                return;
                            })
                                .catch(function (e) {
                                _this._errorBoundary._logError('initializeAsync:fetchAndSaveValues', e);
                                return { success: false, message: e.message };
                            })
                                .then(function () {
                                return;
                            })
                                .finally(function () { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    this._pendingInitPromise = null;
                                    this._ready = true;
                                    this._delayedSetup();
                                    return [2 /*return*/];
                                });
                            }); });
                            return [2 /*return*/, this._pendingInitPromise];
                        });
                    }); }, function () {
                        _this._ready = true;
                        _this._initCalled = true;
                        return Promise.resolve();
                    })];
            });
        });
    };
    StatsigClient.prototype.getEvaluationDetails = function () {
        var _this = this;
        return this._errorBoundary._capture('getEvaluationDetails', function () {
            return _this._store.getGlobalEvaluationDetails();
        }, function () {
            return {
                time: Date.now(),
                reason: StatsigStore_1.EvaluationReason.Error,
            };
        });
    };
    /**
     * Checks the value of a gate for the current user
     * @param {string} gateName - the name of the gate to check
     * @returns {boolean} - value of a gate for the user. Gates are "off" (return false) by default
     * @throws Error if initialize() is not called first, or gateName is not a string
     */
    StatsigClient.prototype.checkGate = function (gateName) {
        return this._checkGateImpl(gateName, 'checkGate');
    };
    StatsigClient.prototype.checkGateWithExposureLoggingDisabled = function (gateName) {
        return this._checkGateImpl(gateName, 'checkGateWithExposureLoggingDisabled');
    };
    StatsigClient.prototype.logGateExposure = function (gateName) {
        var _this = this;
        this._errorBoundary._swallow('logGateExposure', function () {
            _this._logGateExposureImpl(gateName);
        });
    };
    /**
     * Checks the value of a config for the current user
     * @param {string} configName - the name of the config to get
     * @returns {DynamicConfig} - value of a config for the user
     * @throws Error if initialize() is not called first, or configName is not a string
     */
    StatsigClient.prototype.getConfig = function (configName) {
        return this._getConfigImpl(configName, 'getConfig');
    };
    StatsigClient.prototype.getConfigWithExposureLoggingDisabled = function (configName) {
        return this._getConfigImpl(configName, 'getConfigWithExposureLoggingDisabled');
    };
    StatsigClient.prototype.logConfigExposure = function (configName) {
        var _this = this;
        this._errorBoundary._swallow('logConfigExposure', function () {
            _this._logConfigExposureImpl(configName);
        });
    };
    StatsigClient.prototype.getExperiment = function (experimentName) {
        return this.getConfig(experimentName);
    };
    StatsigClient.prototype.getExperimentWithExposureLoggingDisabled = function (experimentName) {
        return this.getConfigWithExposureLoggingDisabled(experimentName);
    };
    StatsigClient.prototype.logExperimentExposure = function (experimentName) {
        this.logConfigExposure(experimentName);
    };
    StatsigClient.prototype.getLayer = function (layerName) {
        return this._getLayerImpl(layerName, 'getLayer');
    };
    StatsigClient.prototype.getLayerWithExposureLoggingDisabled = function (layerName) {
        return this._getLayerImpl(layerName, 'getLayerWithExposureLoggingDisabled');
    };
    StatsigClient.prototype.logLayerParameterExposure = function (layerName, parameterName) {
        var _this = this;
        this._errorBoundary._swallow('logLayerParameterExposure', function () {
            var layer = _this._getLayerFromStore(null, layerName);
            _this._logLayerParameterExposureForLayer(layer, parameterName, true);
        });
    };
    StatsigClient.prototype.logEvent = function (eventName, value, metadata) {
        var _this = this;
        if (value === void 0) { value = null; }
        if (metadata === void 0) { metadata = null; }
        this._errorBoundary._swallow('logEvent', function () {
            if (!_this._logger || !_this._identity._sdkKey) {
                throw new Errors_1.StatsigUninitializedError(Errors_1.StatsigErrorMessage.REQUIRE_INITIALIZE_FOR_LOG_EVENT);
            }
            if (typeof eventName !== 'string' || eventName.length === 0) {
                return;
            }
            var event = (0, LogEvent_1.default)(eventName, _this._identity._user, _this._identity._statsigMetadata, value, metadata);
            _this._logger.log(event);
        });
    };
    StatsigClient.prototype.updateUserWithValues = function (user, values) {
        var _this = this;
        var updateStartTime = Date.now();
        var fireCompletionCallback;
        return this._errorBoundary._capture('updateUserWithValues', function () {
            if (!_this.initializeCalled()) {
                throw new Errors_1.StatsigUninitializedError(Errors_1.StatsigErrorMessage.REQUIRE_ASYNC_INITIALIZE);
            }
            fireCompletionCallback = function (success, error) {
                var cb = _this._options.updateUserCompletionCallback;
                cb === null || cb === void 0 ? void 0 : cb(Date.now() - updateStartTime, success, error);
            };
            _this._identity._user = _this._normalizeUser(user);
            _this._store.bootstrap(values);
            _this._logger.resetDedupeKeys();
            fireCompletionCallback(true, null);
            return true;
        }, function () {
            fireCompletionCallback === null || fireCompletionCallback === void 0 ? void 0 : fireCompletionCallback(false, 'Failed to update user. An unexpected error occured.');
            return false;
        });
    };
    StatsigClient.prototype.updateUser = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var updateStartTime, fireCompletionCallback;
            var _this = this;
            return __generator(this, function (_a) {
                updateStartTime = Date.now();
                return [2 /*return*/, this._errorBoundary._capture('updateUser', function () { return __awaiter(_this, void 0, void 0, function () {
                        var currentUser;
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!this.initializeCalled()) {
                                        throw new Errors_1.StatsigUninitializedError(Errors_1.StatsigErrorMessage.REQUIRE_ASYNC_INITIALIZE);
                                    }
                                    fireCompletionCallback = function (success, error) {
                                        var cb = _this._options.updateUserCompletionCallback;
                                        cb === null || cb === void 0 ? void 0 : cb(Date.now() - updateStartTime, success, error);
                                    };
                                    this._identity._user = this._normalizeUser(user);
                                    this._store.updateUser();
                                    this._logger.resetDedupeKeys();
                                    if (!(this._pendingInitPromise != null)) return [3 /*break*/, 2];
                                    return [4 /*yield*/, this._pendingInitPromise];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2:
                                    if (this._options.localMode) {
                                        fireCompletionCallback(true, null);
                                        return [2 /*return*/, Promise.resolve(true)];
                                    }
                                    currentUser = this._identity._user;
                                    this._pendingInitPromise = this._fetchAndSaveValues(currentUser).finally(function () {
                                        _this._pendingInitPromise = null;
                                    });
                                    return [2 /*return*/, this._pendingInitPromise
                                            .then(function () {
                                            fireCompletionCallback(true, null);
                                            return Promise.resolve(true);
                                        })
                                            .catch(function (error) {
                                            fireCompletionCallback(false, "Failed to update user: ".concat(error));
                                            return Promise.resolve(false);
                                        })];
                            }
                        });
                    }); }, function () {
                        fireCompletionCallback(false, 'Failed to update user. An unexpected error occured.');
                        return Promise.resolve(false);
                    })];
            });
        });
    };
    /**
     * Informs the statsig SDK that the client is closing or shutting down
     * so the SDK can clean up internal state
     */
    StatsigClient.prototype.shutdown = function () {
        var _this = this;
        this._errorBoundary._swallow('shutdown', function () {
            _this._logger.shutdown();
        });
    };
    /**
     * @returns The Statsig stable ID used for device level experiments
     */
    StatsigClient.prototype.getStableID = function () {
        var _this = this;
        return this._errorBoundary._capture('getStableID', function () { return _this._identity._statsigMetadata.stableID; }, function () { return ''; });
    };
    StatsigClient.prototype.initializeCalled = function () {
        return this._initCalled;
    };
    StatsigClient.prototype.overrideGate = function (gate, result) {
        this._setOverride('gates', gate, result);
    };
    StatsigClient.prototype.overrideConfig = function (config, result) {
        this._setOverride('configs', config, result);
    };
    StatsigClient.prototype.overrideLayer = function (layer, result) {
        this._setOverride('layers', layer, result);
    };
    StatsigClient.prototype.setOverrides = function (overrides) {
        var _this = this;
        this._errorBoundary._swallow('setOverrides', function () {
            _this._overrides = overrides !== null && overrides !== void 0 ? overrides : (0, LocalOverrides_1.makeEmptyOverrides)();
            (0, LocalOverrides_1.saveOverridesToLocalStorage)(_this._overrides);
        });
    };
    StatsigClient.prototype.getOverrides = function () {
        var _this = this;
        return this._errorBoundary._capture('getOverrides', function () { return _this._overrides; }, function () { return (0, LocalOverrides_1.makeEmptyOverrides)(); });
    };
    // Private
    StatsigClient.prototype._delayedSetup = function () {
        var _this = this;
        this._errorBoundary._swallow('delayedSetup', function () {
            _this._identity.saveStableID();
            _this._logger.sendSavedRequests().then(function () {
                /* noop */
            });
        });
    };
    StatsigClient.prototype._normalizeUser = function (user) {
        var userCopy = {};
        try {
            userCopy = JSON.parse(JSON.stringify(user));
        }
        catch (error) {
            throw new Errors_1.StatsigInvalidArgumentError('User object must be convertable to JSON string.');
        }
        if (this._options.environment != null) {
            userCopy = __assign(__assign({}, userCopy), { statsigEnvironment: this._options.environment });
        }
        return userCopy;
    };
    StatsigClient.prototype._ensureStoreLoaded = function () {
        if (!this._store.isLoaded()) {
            throw new Errors_1.StatsigUninitializedError();
        }
    };
    StatsigClient.prototype._getEvaluationDetailsForError = function () {
        return {
            time: Date.now(),
            reason: StatsigStore_1.EvaluationReason.Error,
        };
    };
    StatsigClient.prototype._fetchAndSaveValues = function (user, timeout) {
        if (timeout === void 0) { timeout = this._options.initTimeoutMs; }
        return __awaiter(this, void 0, void 0, function () {
            var sinceTime, previousDerivedFields;
            var _this = this;
            return __generator(this, function (_a) {
                sinceTime = null;
                sinceTime = this._store.getLastUpdateTime(user);
                previousDerivedFields = this._store.getPreviousDerivedFields(user);
                return [2 /*return*/, this._network
                        .fetchValues(user, sinceTime, timeout, previousDerivedFields)
                        .eventually(function (json) {
                        var _a;
                        if (!(0, ResponseVerification_1.verifySDKKeyUsed)(json, (_a = _this._sdkKey) !== null && _a !== void 0 ? _a : '', _this._errorBoundary)) {
                            return;
                        }
                        if (json === null || json === void 0 ? void 0 : json.has_updates) {
                            _this._store.save(user, json, false);
                        }
                    })
                        .then(function (json) { return __awaiter(_this, void 0, void 0, function () {
                        var _this = this;
                        return __generator(this, function (_a) {
                            return [2 /*return*/, this._errorBoundary._swallow('fetchAndSaveValues', function () { return __awaiter(_this, void 0, void 0, function () {
                                    var _a;
                                    return __generator(this, function (_b) {
                                        switch (_b.label) {
                                            case 0:
                                                if (!(0, ResponseVerification_1.verifySDKKeyUsed)(json, (_a = this._sdkKey) !== null && _a !== void 0 ? _a : '', this._errorBoundary)) {
                                                    return [2 /*return*/];
                                                }
                                                if (!(json === null || json === void 0 ? void 0 : json.has_updates)) return [3 /*break*/, 2];
                                                return [4 /*yield*/, this._store.save(user, json)];
                                            case 1:
                                                _b.sent();
                                                return [3 /*break*/, 3];
                                            case 2:
                                                if (json === null || json === void 0 ? void 0 : json.is_no_content) {
                                                    this._store.setEvaluationReason(StatsigStore_1.EvaluationReason.NetworkNotModified);
                                                }
                                                _b.label = 3;
                                            case 3: return [2 /*return*/];
                                        }
                                    });
                                }); })];
                        });
                    }); })];
            });
        });
    };
    StatsigClient.prototype._checkGateImpl = function (gateName, callsite) {
        var _this = this;
        return this._errorBoundary._capture(callsite, function () {
            if (typeof _this._overrides.gates[gateName] === 'boolean') {
                return _this._overrides.gates[gateName];
            }
            var result = _this._getGateFromStore(gateName);
            if (callsite === 'checkGate') {
                _this._logGateExposureImpl(gateName, result);
            }
            return result.gate.value === true;
        }, function () { return false; });
    };
    StatsigClient.prototype._getGateFromStore = function (gateName) {
        this._ensureStoreLoaded();
        if (typeof gateName !== 'string' || gateName.length === 0) {
            throw new Errors_1.StatsigInvalidArgumentError('Must pass a valid string as the gateName.');
        }
        return this._store.checkGate(gateName);
    };
    StatsigClient.prototype._logGateExposureImpl = function (gateName, fetchResult) {
        var isManualExposure = !fetchResult;
        var result = fetchResult !== null && fetchResult !== void 0 ? fetchResult : this._getGateFromStore(gateName);
        var gate = result.gate;
        this._logger.logGateExposure(this._identity._user, gateName, gate.value, gate.rule_id, gate.secondary_exposures, result.evaluationDetails, isManualExposure, this._store.getBootstrapMetadata());
    };
    StatsigClient.prototype._getConfigImpl = function (configName, callsite) {
        var _this = this;
        return this._errorBoundary._capture(callsite, function () {
            if (_this._overrides.configs[configName]) {
                return new DynamicConfig_1.default(configName, _this._overrides.configs[configName], 'local_override', {
                    reason: StatsigStore_1.EvaluationReason.LocalOverride,
                    time: Date.now(),
                });
            }
            var result = _this._getConfigFromStore(configName);
            if (callsite === 'getConfig') {
                _this._logConfigExposureImpl(configName, result);
            }
            return result;
        }, function () { return _this._getEmptyConfig(configName); });
    };
    StatsigClient.prototype._getConfigFromStore = function (configName) {
        this._ensureStoreLoaded();
        if (typeof configName !== 'string' || configName.length === 0) {
            throw new Errors_1.StatsigInvalidArgumentError('Must pass a valid string as the configName.');
        }
        return this._store.getConfig(configName);
    };
    StatsigClient.prototype._logConfigExposureImpl = function (configName, config) {
        var isManualExposure = !config;
        var localConfig = config !== null && config !== void 0 ? config : this._getConfigFromStore(configName);
        this._logger.logConfigExposure(this._identity._user, configName, localConfig._ruleID, localConfig._secondaryExposures, localConfig._evaluationDetails, isManualExposure, this._store.getBootstrapMetadata());
    };
    StatsigClient.prototype._getLayerImpl = function (layerName, callsite) {
        var _this = this;
        return this._errorBoundary._capture(callsite, function () {
            if (_this._overrides.layers[layerName]) {
                return Layer_1.default._create(layerName, _this._overrides.layers[layerName], 'local_override', {
                    reason: StatsigStore_1.EvaluationReason.LocalOverride,
                    time: Date.now(),
                });
            }
            var logFunc = callsite === 'getLayer'
                ? _this._logLayerParameterExposureForLayer
                : null;
            return _this._getLayerFromStore(logFunc, layerName);
        }, function () {
            return Layer_1.default._create(layerName, {}, '', _this._getEvaluationDetailsForError());
        });
    };
    StatsigClient.prototype._getLayerFromStore = function (logParameterFunction, layerName) {
        this._ensureStoreLoaded();
        if (typeof layerName !== 'string' || layerName.length === 0) {
            throw new Errors_1.StatsigInvalidArgumentError('Must pass a valid string as the layerName.');
        }
        return this._store.getLayer(logParameterFunction, layerName);
    };
    StatsigClient.prototype._getEmptyConfig = function (configName) {
        return new DynamicConfig_1.default(configName, {}, '', this._getEvaluationDetailsForError());
    };
    StatsigClient.prototype._setOverride = function (type, key, result) {
        if (result == null) {
            delete this._overrides[type][key];
        }
        else {
            this._overrides[type][key] = result;
        }
        this.setOverrides(this._overrides);
    };
    return StatsigClient;
}());
exports.default = StatsigClient;
